import { z } from 'zod'

// Base64 stays below the function response limit even after the JSON envelope is added.
export const SESSION_RESPONSE_CHUNK_SIZE = 1024 * 1024
export const SessionResponseChunkSchema = z.object({
  encoding: z.literal('gzip-base64'),
  sha256: z.string().regex(/^[a-f0-9]{64}$/),
  part: z.number().int().nonnegative(),
  parts: z.number().int().positive(),
  data: z.string().max(SESSION_RESPONSE_CHUNK_SIZE).regex(/^[A-Za-z0-9+/]*={0,2}$/),
}).refine(chunk => chunk.part < chunk.parts)
